module.exports = __webpack_public_path__ + "img/8.bccdbf93.png";